import {
  ChangeDetectorRef,
  Component,
  Input,
  HostListener,
  OnDestroy,
  OnInit,
  Sanitizer,
  AfterViewInit,
  ElementRef,
  NO_ERRORS_SCHEMA,
  Renderer2, AfterContentChecked, AfterViewChecked
} from '@angular/core';
import { ROUTE_TRANSITION } from '../../../app.animation';
import * as fromRoot from '../../../reducers/index';
import { Store } from '@ngrx/store';
import {AuthenticationService} from '../../../authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalService} from '../../../global.service';
import {HttpClient, HttpEvent, HttpEventType, HttpHeaders} from '@angular/common/http';
import {SeasonsService} from '../../seasons/seasons.service';
import {interval} from 'rxjs';
import {SignupDialogComponent} from '../../seasons/race-signup/signup-dialog/signup-dialog.component';
import {MatDialog} from '@angular/material';
import {UsersService} from '../../users/users.service';
import {EventsService} from '../../events/events.service';
import {DomSanitizer} from '@angular/platform-browser';
import {AdSharedServiceService} from '../../../ad-shared-service.service';
import {YearlyrecapComponent} from '../../yearlyrecap/yearlyrecap.component';

// @ts-ignore
@Component({
  selector: 'elastic-dashboard-statistics',
  templateUrl: './dashboard-statistics.component.html',
  styleUrls: ['./dashboard-statistics.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class DashboardStatisticsComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked  {

  @Input() hideHeader: boolean;


  maxEvents = 3;
  end = 2;
  start = 0;

  onlySeriesWithNextRace = true;

  dashboardEvents = [];

  yt = {
    'videoId': '',
    'embedLink': ''
  };

  ytLoaded = false;

  sss = [];

  upcomingBroadcasts = [];
  innerWidth: number;
  timer: any;

  sks: any;

  dashboardSessionNav = 'season';

  layoutGap = {
    'lt-md': '16px',
    'gt-md': '24px'
  };

  loaded = false;

  dashboardStats = {
    'laps' : 0,
    'users': 0,
    'leagues': 0,
    'races': 0,
    'sr' : 0,
    'today' : 0,
    'racing': 0
  };

  weisheiten = [
    {'text':'Wer später bremst, ist länger schnell.','name':''},
    {'text':'Zweiter zu sein bedeutet der Erste zu sein, der verliert.','name':'Ayrton Senna'},
    {'text':'Manchmal gewinnt man, manchmal verliert man, manchmal verschrottet man.','name':'Dale Earnhardt'},
    {'text':'Im Prinzip geht es darum, als erster Feierabend zu machen.','name':'Michael Schumacher'},
    {'text':'Rennen zu beenden ist wichtig, aber Rennen fahren ist wichtiger.','name':'Dale Earnhardt'},
    {'text':'Gute Fahrer haben die Fliegenreste auf den Seitenscheiben.','name':'Walter Röhrl'},
    {'text':'Ein Auto ist erst dann schnell genug, wenn man morgens davor steht und Angst hat, es aufzuschließen.','name':'Walter Röhrl'},
    {'text':'Wenn du den Baum siehst, in den du rein fährst, hast du untersteuert. Wenn du ihn nur hörst, hast du übersteuert.','name':'Walter Röhrl'},
    {'text':'Trinken ist sicherer als Sport. Da verletzt man sich nicht, man bekommt nur einen Kater.','name':'Kimi Räikkönen'},
    {'text':'Es ist nicht einfach, perfekt zu sein, aber irgendeiner muss es sein.','name':'Niki Lauda'},
    {'text':'Hätte auch scheißer sein können.','name':'Christian Zanger'},
    {'text':'ICH DREH DURCH!','name':'Lucas Tippach'}
  ];

  weisheit = {};

  dashboardSessions = [];

  flexWidth = {
    'lt-sm': 'auto',
    'gt-sm': `calc(50% - ${this.layoutGap['lt-md']}`,
    'gt-md': `calc(50% - ${this.layoutGap['gt-md']}`
  };

  layout: string;

  layoutColumnOnBoxed = 'row';

  season = {
    'season_name' : '',
    'series' : [],
    'special_events': []
  };

  sim = 0;
  userSR: number;
  userLicense: boolean;
  anybodyLive = false;

  eventheight = 600;

  simracingexpo = false;

  casekingImg = '';

  constructor(
    private store: Store<fromRoot.State>,
    private cd: ChangeDetectorRef,
    private authenticationService : AuthenticationService, private route: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService,
    private http: HttpClient,
    private seasonsService: SeasonsService,
    private dialog: MatDialog,
    private usersService: UsersService,
    private eventsService: EventsService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private el: ElementRef,
    private AdSharedService: AdSharedServiceService,
    ) { }

  randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ngAfterViewInit() {

  }

  formatNumber (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  getOffset( el ) {
    var _x = 0;
    var _y = 0;
    while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
      _x += el.offsetLeft - el.scrollLeft;
      _y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }
    console.log({ top: _y, left: _x });
    return { top: _y, left: _x };
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;

    /* ADs IMGs */
    this.casekingImg = this.globalService.cdnUrl + "/../y/" + this.globalService.encode('https://lowfuelmotorsport.com/assets/img/prtn2/caseking_frontpage_lian_li.jpg?arch=' + this.globalService.makeid(23));
    //this.skrightimg = this.globalService.cdnUrl + "/../i/" + this.globalService.encode('https://lowfuelmotorsport.com/assets/img/prtn2/syncmesh_side.gif?arch=' + this.globalService.makeid(23));



    let now = new Date();

    let redirect = null;
    let data = '';

    data = this.route.snapshot.queryParams['data'];

    if (this.route.snapshot.queryParams['redirect']) {
      redirect = this.route.snapshot.queryParams['redirect'];
    }



    this.getSeason();

    this.getDashboardEvents();

    this.getLatestYtVid();

    // this.userSR = this.authenticationService.getUserSr();
    this.userLicense = this.authenticationService.isLicenseValid();
    if (data && data != null) {
      const loginData = JSON.parse(atob(data));
      console.log(loginData);
      localStorage.clear();
      if (loginData.accessToken) {

        this.authenticationService.login(loginData, redirect);
      }
    }

    if (this.authenticationService.isLoggedIn()) {
      if (location.hostname == "stage.lowfuelmotorsport.com" || location.hostname == "localhost") {
        //this.sim = 4;
      }
      const headers = new HttpHeaders();


      let tokenObject = JSON.parse(localStorage.getItem('currentUser'));

      let abcheaders = {
        'Authorization': 'Bearer ' + tokenObject.accessToken
      };

      console.log(tokenObject);

      this.http.get(this.globalService.apiUrl + '/user', {headers: abcheaders}).subscribe((response: any) => {

              tokenObject.userData = response;

              if (response.deleted) {
                localStorage.removeItem('currentUser');
                alert('Your account was previously deleted, so no login possible with this steam id!');
                window.document.location.href = '/';
              } else {

                localStorage.setItem('currentUser', JSON.stringify(tokenObject));
                this.globalService.sim_id = tokenObject.userData.fav_sim;
                console.log("FAV SIM:" + this.globalService.sim_id);
                this.sim = tokenObject.userData.fav_sim;
                console.log("THIS SIM:" + this.sim);
                if (this.authenticationService.currentUser.vorname == '' || this.authenticationService.currentUser.nachname == '') {

                  //this.openUserDataDialog();

                }


              }


              //console.log("USER DATA OBJECT UPDATED!");


        });



      this.getBroadcasts();

    }


    this.hideHeader = true;

    this.store.select(fromRoot.getLayout).subscribe((layout) => {
      this.layout = layout;

      if (layout === 'gamma') {
        this.layoutColumnOnBoxed = 'column';
      } else {
        this.layoutColumnOnBoxed = 'row';
      }

      this.cd.markForCheck();
    });

    this.globalService.getDashboardStats().subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.dashboardStats = response.body;
            this.cd.detectChanges();
            break;
        }
      });

    this.getData();

    this.timer = interval(1000).subscribe(x => {
      this.cd.detectChanges();
    });

    this.weisheit = this.weisheiten[this.randomNumber(0, (this.weisheiten.length - 1))];

  }



  getData() {
    /*
    this.globalService.getDashboardUpcomingRaces().subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.dashboardSessions = response.body;
            this.dashboardSessions.forEach((item, index) => {
              item.signupCloseDate = new Date(item.signupCloses + '+0100');
              item.serverOpenDate = new Date(item.race_date + '+0100');
              item.signedUp = false;

              if (item.session_broadcaster > 0) {
                this.usersService.getUsersData(item.session_broadcaster).subscribe(
                  ( response2: HttpEvent<any> ) => {
                    switch (response2.type) {
                      case HttpEventType.Response:
                        item.broadcaster = response2.body;
                        break;
                    }
                  });
              }

              this.seasonsService.checkSignUp(item.race_id).subscribe(
                // tslint:disable-next-line:no-shadowed-variable
                ( response: HttpEvent<any> ) => {
                  switch (response.type) {
                    case HttpEventType.Response:
                      item.signedUp = response.body.success;
                      if (response.body.car_model) {
                        item.car_model = response.body.car_model;
                        item.car = response.body.car;
                      }
                      break;
                  }
                });
            });


            this.cd.detectChanges();
            break;
        }
      });

     */
  }

  openSignupDialog(race) {

    if (this.authenticationService.isLoggedIn()) {

      this.dialog.open(SignupDialogComponent, {
        data: {race: race, event: race.event}
      }).afterClosed().subscribe(resp => {
        if (resp) {
          //console.log(resp);
          this.getData();
        }
      });

    } else {
      this.authenticationService.redirectToLogin();
    }

  }

  withdraw(race_id) {

    if (this.authenticationService.isLoggedIn()) {
      if (confirm('Do you really want to withdraw from the race?')) {

        this.seasonsService.withdraw(race_id).subscribe(
          ( response: HttpEvent<any> ) => {
            switch (response.type) {
              case HttpEventType.Response:
                //this.registered.emit('registered');
                this.getData();
                break;
            }
          });

      }
    }

  }

  openBroadcaster(broadcaster: any) {
    window.open("https://twitch.tv/" + broadcaster.twitch_channel);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    this.AdSharedService.onDestroy(this.el);
  }

  getBroadcasts() {
      this.anybodyLive = false;
      this.eventsService.getUpcomingBroadcasts().subscribe(

        ( response: HttpEvent<any> ) => {

          switch (response.type) {
            case HttpEventType.Response:
              //this.upcomingBroadcasts = response.body.data;
              /*
              this.upcomingBroadcasts.push({
                embedLink: this.sanitizer.bypassSecurityTrustResourceUrl("https://player.twitch.tv/?channel=virtualendurancemasters&parent=lowfuelmotorsport.com&autoplay=true&muted=true"),
                live_date: new Date('2023-11-25 12:00:00'),
                race_date: '2023-11-25 12:00:00',
                is_live: true,
                event_name: 'VEM 24h Bathurst | English',
                title: 'VEM 24h Bathurst | English',
                language: 'ENG',
                session_running: 1,
                broadcaster : {twitch_channel: 'virtualendurancemasters'},
                track_name: 'Mount Panorama',
                split: 1,
                platform: 'twitch',
                link: 'https://twitch.tv/virtualendurancemasters'
              });

              this.upcomingBroadcasts.push({
                embedLink: this.sanitizer.bypassSecurityTrustResourceUrl("https://player.twitch.tv/?channel=lowfuelmotorsport_de&parent=lowfuelmotorsport.com&autoplay=true&muted=true"),
                live_date: new Date('2024-01-23 19:00:00'),
                race_date: '2023-01-23 19:00:00',
                is_live: true,
                event_name: 'ACC GT2 DLC PREVIEW EVENT',
                title: 'ACC GT2 DLC PREVIEW EVENT',
                language: 'DEU',
                session_running: 1,
                broadcaster : {twitch_channel: 'lowfuelmotorsport_de'},
                track_name: '',
                split: 1,
                platform: 'twitch',
                link: 'https://twitch.tv/lowfuelmotorsport_de'
              });

              this.upcomingBroadcasts.push({
                embedLink: this.sanitizer.bypassSecurityTrustResourceUrl("https://player.twitch.tv/?channel=topracingtv&parent=lowfuelmotorsport.com&autoplay=true&muted=true"),
                live_date: new Date('2023-11-25 12:00:00'),
                race_date: '2023-11-25 12:00:00',
                is_live: true,
                event_name: 'VEM 24h Bathurst | Espanol',
                title: 'VEM 24h Bathurst | Espanol',
                language: 'ESP',
                session_running: 1,
                broadcaster : {twitch_channel: 'topracingtv'},
                track_name: 'Mount Panorama',
                split: 1,
                platform: 'twitch',
                link: 'https://twitch.tv/topracingtv'
              });

              this.anybodyLive = true;
              */

              if (response.body.data.length > 0) {
                response.body.data.forEach( ( broadcast: any) => {
                  broadcast.embedLink = this.sanitizer.bypassSecurityTrustResourceUrl(broadcast.embedLink);
                  broadcast.live_date = new Date(broadcast.live_date);
                  broadcast.is_live = new Date() > broadcast.live_date ? true : false;
                  if (broadcast.is_live) {
                    this.anybodyLive = true;
                  }
                  this.upcomingBroadcasts.push(broadcast);
                });
              }

              this.cd.detectChanges();
              console.log(this.upcomingBroadcasts);
              break;
          }
        });





  }

  getDashboardEvents() {
    this.eventsService.getAllEventsForDashboard().subscribe( (data: any) => {
      if (data) {
        this.dashboardEvents = data;
      }
    });
  }

  getSeason() {
    this.seasonsService.getMinifiedSeason().subscribe( (data: any) => {
      if (data) {
        this.season = data;

        Object.keys(this.season.series).forEach( (sim) => {
          this.sss.push(sim);
        });

        Object.keys(this.season.series).forEach( (sim) => {
          console.log(sim);
          this.season.series[sim].series.forEach( (series) => {
            if (series.next_race) {
              series.next_race = new Date(series.next_race);
            }
            if (this.authenticationService.isLoggedIn()) {
              series.unlocked = this.globalService.checkEligible(series.min_sr, series.max_sr, series.min_license, this.authenticationService.getUserSimLicense(series.sim_id), this.authenticationService.getUserSr());
            } else {
              series.unlocked = false;
            }
          });
        });

        Object.keys(this.season.special_events).forEach( (sim) => {
          console.log(sim);
          this.season.special_events[sim].series.forEach( (series) => {
            if (series.next_race) {
              series.next_race = new Date(series.next_race);
            }
            if (this.authenticationService.isLoggedIn()) {
              series.unlocked = this.globalService.checkEligible(series.min_sr, series.max_sr, series.min_license, this.authenticationService.getUserSimLicense(series.sim_id), this.authenticationService.getUserSr());
            } else {
              series.unlocked = false;
            }
          });
        });

        this.loaded = true;
        this.cd.detectChanges();
      }
    });
  }

  changeSim(i) {
    Object.keys(this.season.series).forEach( (sim, index) => {
      if (i == index) {
        this.globalService.setFavSim(this.season.series[sim].sim_id);
        this.sim = this.season.series[sim].sim_id;
        if (this.season.series[sim].series.length > 6) {
          this.maxEvents = 3;
        } else {
          this.maxEvents = 2;
        }
      }
    });



  }

  getLatestYtVid() {
    this.globalService.getLatestYtVid().subscribe( (data: any) => {

      if (data) {
        this.ytLoaded = true;
        this.yt = data;
        // @ts-ignore
        this.yt.embedLink =  this.sanitizer.bypassSecurityTrustResourceUrl(this.yt.embedLink);
      }

    });
  }

  events(step) {
    this.start = this.start + step;
    this.end = this.end + step;
  }

  ngAfterViewChecked(): void {
    this.AdSharedService.OnInit(this.el, this.renderer);
  }

  recap() {
    this.dialog.open(YearlyrecapComponent);
  }

}
